import { useMutation } from '@tanstack/react-query';
import { toast } from 'design-system';

import { http } from '@/services/http';

export interface SendShareEmailParams {
  content: string;
  recipient: string;
  url: string;
  extraPayload?: Record<string, string>;
}

export const useSendShareEmail = () => {
  return useMutation({
    mutationKey: ['share', 'send-email'] as const,

    mutationFn: async ({ content, recipient, url, extraPayload }: SendShareEmailParams) => {
      await http.go.post('/share', { content, recipient, url, ...extraPayload });
    },
    onMutate: () => {
      toast.add({
        id: 'loading',
        title: 'Email is sending, please wait...',
        type: 'loading',
        timeout: 0
      });
    },
    onSuccess: () => {
      toast.add({ title: 'Email sent!', type: 'success', timeout: 5000 });
    },
    onError: () => {
      toast.add({ title: 'Something went wrong!', type: 'error', timeout: 5000 });
    },
    onSettled: () => {
      toast.close('loading');
    }
  });
};
